import { useRouteLoaderData } from 'react-router';
import LocatorApi from '@/lib/LocatorApi';
export default async function placeLoader({ params }) {
    // TODO(WRAP-207): Use params.id instead
    const location = LocatorApi.getInstance().get(`location/${params.placeName}/${params.placePostcode}`);
    return {
        location,
    };
}
export function usePlaceLoaderData() {
    return useRouteLoaderData('place');
}
